<template>
    <CardDropdownSm :item="questionData">
        <template #icon>
            <FaqIcon class="flex-shrink-0 w-4 h-4 ct-fg-2" />
        </template>

        <template #extra>
            <InvisibleIcon
                v-if="question.hide"
                @click.stop="toggleHide"
                class="flex-shrink-0 w-4 h-4 ct-fg-4 hover:ct-fg-2"
            />
        </template>
    </CardDropdownSm>
</template>

<script>
import { markRaw } from "vue";
import {
    FaqIcon,
    PencilSquareIcon,
    CopyDocumentIcon,
    TrashBinIcon,
    VisibleIcon,
    InvisibleIcon,
} from "@easy/ui/icons";
import { CardDropdownSm } from "@easy/ui/cards";

export default {
    components: {
        FaqIcon,
        CardDropdownSm,
        InvisibleIcon,
    },
    props: {
        question: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showLink: false,
        };
    },
    emits: ["edit", "delete", "duplicate"],
    computed: {
        questionData() {
            return {
                title: this.question.question,
                actions: [
                    {
                        label: this.$t("shared.edit"),
                        icon: markRaw(PencilSquareIcon),
                        handler: () => this.$emit("edit"),
                    },
                    {
                        label: this.$t("shared.duplicate"),
                        icon: markRaw(CopyDocumentIcon),
                        handler: () => this.$emit("duplicate"),
                    },
                    {
                        label: this.question.hide ? this.$t("shared.show") : this.$t("shared.hide"),
                        icon: this.question.hide ? markRaw(VisibleIcon) : markRaw(InvisibleIcon),
                        handler: this.toggleHide,
                    },
                    { isDivider: true },
                    {
                        label: this.$t("shared.delete"),
                        icon: markRaw(TrashBinIcon),
                        isDanger: true,
                        handler: () => this.$emit("delete"),
                    },
                ],
            };
        },
    },
    methods: {
        toggleHide() {
            this.question.hide = !this.question.hide;
            if (!this.question._created) {
                this.question._changed = true;
            }
        },
    },
};
</script>
